// removed by extract-text-webpack-plugin
module.exports = {"Spinner":"spinner__Spinner__20CEo","spin":"spinner__spin__2dxiD"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Spinner/spinner.css
// module id = 966
// module chunks = 2